import {HttpClient} from "../../http/HttpClient.jsx";
import {EventBus} from "../../bus/EventBus.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";
import {GoogleAnalytics} from "../../GoogleAnalytics.jsx";

export const acceptOrder = async order => {
    const acceptedOrder = await HttpClient.safePost(`/api/events/${order.eventId}/acceptV2`, {
        updatedAt: order.updatedAt
    });

    if (acceptedOrder.error) {
        EventBus.triggerError("server-error", {content: {description: acceptedOrder.error}}, acceptedOrder.error);
        message.error(new StringBuilder("שגיאה בעת אישור ההזמנה").append(`(${acceptedOrder.error})`).toString());
    } else {
        message.success("ההזמנה אושרה בהצלחה");
    }
    GoogleAnalytics.event("Session Proposal", "Accept", order.eventId);
};

export const cancelOrder = async order => {
    const canceledOrder = await HttpClient.post(
        `/admin/api/orders/${order.eventId}/cancel?updatedAt=${order.updatedAt}`
    );

    if (canceledOrder.error) {
        message.error(new StringBuilder("שגיאה בעת ביטול ההזמנה").append(`(${canceledOrder.error})`).toString());
    } else {
        message.success("ההזמנה בוטלה בהצלחה");
    }
};

export const deliveredOrder = async order => {
    const deliveredOrder = await HttpClient.post(`/api/events/${order.eventId}/delivered`);

    if (deliveredOrder.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטאטוס ההזמנה לסופק").append(`(${deliveredOrder.error})`).toString()
        );
    } else {
        message.success("סטאטוס ההזמנה שונה לסופקה בהצלחה");
    }
};
